export default __webpack_public_path__ + "static/media/AcornMallCarpark_25.34d5b7ec.png";